import React from "react";
import {connect} from "react-redux";
import locale from "../../locale";
import onBannerClick from "../../actions/onBannerClick";
import {showPopup} from "../../actions/showPopup";
import {watchLandingPresentationRequest} from "../../api";

function BrandPreviewVideo({videoUrl})
{
	if (!videoUrl) {
		return null;
	}

	let iframe = `<iframe src="${videoUrl}" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>`;
	let className = 'exposition-video';

	if (!videoUrl.match(/:\/\/broadcast\.comdi\.com\//)) {
		className += ' aspect_16x9';
	}

	return (
		<div className={className} dangerouslySetInnerHTML={{__html: iframe}} />
	);
}

function BrandPreviewImage({imageUrl})
{
	return (
		<img src={imageUrl} alt="" style={{width: '100%'}} />
	);
}

function BrandButton(props)
{
	const linkProps = {};

	linkProps.className = 'exposition-brand-button' +
		(props.icon ? ' exposition-brand-' + props.icon : '')
	;
	const title = locale.getProperty(props, 'title');

	const showTrackingMessage = props.hasOwnProperty('showTrackingMessage') && props.showTrackingMessage;

	if (props.href) {
		linkProps.href = props.href;
		linkProps.target = '_blank';
	}

	if (props.trackingKey) {
		linkProps.onClick = async () => {
			const formData = new FormData();
			formData.append('eventId', props.event.id);
			formData.append('presentationKey', props.trackingKey);

			const isSend = await watchLandingPresentationRequest(formData)
				.then(response => true)
			;

			if (!isSend) {
				showTrackingMessage && props.showPopup(locale.get('exposition-trackingRequest-failed'));

				return;
			}

			showTrackingMessage && props.showPopup(locale.get('exposition-trackingRequest-success'));
		};
	}

	return <a {...linkProps}>{title}</a>;
}

function BrandInfo(props)
{
	const {onReturn, siteUrl, contacts} = props;

	const BrandContacts = () => {
		if (!siteUrl && !contacts) {
			return null;
		}

		const rows = [];
		if (siteUrl) {
			rows.push(
				<a href={siteUrl} target="_blank">{siteUrl.match(/:\/\/([^\/]+)/)[1]}</a>
			);
		}

		if (contacts) {
			contacts.forEach((contact) => {
				const {emails, phones} = contact;
				const name = locale.getProperty(contact, 'name');

				rows.push(
					<div>
						{name ? <span>{name}</span> : null}
						{' '}
						{emails ? emails.map((email, index) => <a href={`mailto:${email}`} key={index}>{email}</a>) : null}
						{' '}
						{phones ? phones.map((phone, index) => <a href={`tel:${phone.replace(/[^+0-9]/g, '')}`} key={index}>{phone}</a>) : null}
					</div>
				);
			});
		}

		return (
			<div className="exposition-brand-contacts">
				<h3>Контакты:</h3>
				{rows.map((row, index) => <div key={index}>{row}</div>)}
			</div>
		);
	};

	let logos = props.innerLogoUrl || props.logoUrl;
	if (!Array.isArray(logos)) {
		logos = [logos];
	}

	return (
		<div>
			<table className="exposition-brand-header" style={{width: '100%'}}>
				<thead>
				<tr>
					<td className="exposition-brand-header-button-cell">
						<button onClick={onReturn} />
					</td>
					<td>
						{locale.getProperty(props, 'name')}
					</td>
					{logos.length > 0 && logos[0] &&
					<td className="exposition-brand-header-logo-cell">
						{logos.map((logoUrl, index) =>
							<img src={logoUrl} alt={locale.getProperty(props, 'name')} key={index} style={props.styleInnerLogo} />
						)}
					</td>
					}
				</tr>
				</thead>
			</table>

			{
				props.videoEmbedUrl ? <BrandPreviewVideo videoUrl={props.videoEmbedUrl}/> :
					(props.posterUrl ? <BrandPreviewImage imageUrl={props.posterUrl} /> : null)
			}


			<div className="exposition-brand-links">
				{(props.buttons || []).map((button, index) => <BrandButton
					key={index}
					{...button}
					event={props.event}
					showPopup={props.showPopup}
				/>)}
			</div>

			<div className="exposition-brand-description">
				{locale.getProperty(props, 'description').split("\n").map((text, index) => <p key={`brand_description_${index}`} dangerouslySetInnerHTML={{__html: text}} />)}

				<BrandContacts />
			</div>

		</div>
	);
}

class LayoutExposition extends React.Component
{
	constructor(props, content)
	{
		super(props, content);

		this.state = {
			currentBrand: null,
		};
	}

	selectBrand(brand)
	{
		if (brand && brand.trackingKey) {
			onBannerClick(this.props.event.id, brand.trackingKey);
		}

		this.setState({currentBrand: brand});
	}

	renderBrandInfo()
	{
		const {currentBrand} = this.state;
		const {event, showPopup} = this.props;

		return (
			<BrandInfo {...currentBrand} onReturn={() => this.selectBrand(null)} event={event} showPopup={showPopup} />
		);
	}

	renderBrands()
	{
		const {settings} = this.props;

		const Content = ({brand}) => {
			if (brand.logoUrl) {
				return <div className="exposition-brand-preview-logo"
							style={{backgroundImage: `url(${brand.logoUrl})`}}/>;
			}

			return <table><tr><td>{locale.getProperty(brand, 'name')}</td></tr></table>
		};

		return (
			<div>
				{settings.brands.map((brand, index) =>
					<article className="exposition-brand-preview" key={index}
							 onClick={() => this.selectBrand(brand)}
							 style={Object.assign({}, settings.styleBlock, brand.styleBlock)}
					>
						<Content brand={brand} />
					</article>
				)}
			</div>
		);
	}

	render()
	{
		const {settings} = this.props;
		const {currentBrand} = this.state;

		if (!settings) {
			return null;
		}

		return (
			<aside className="section-exposition" id="exposition" style={settings.style}>
				<h1>{locale.getProperty(settings, 'title') || locale.get('layer-exposition-title')}</h1>
				<div className="landing-nav-section-text">
					{currentBrand ? this.renderBrandInfo() : this.renderBrands()}
				</div>
			</aside>
		);
	}
}

const mapStateToProps = (store) => ({
	event: store.event,
});

const mapDispatchToProps = (dispatch) => ({
	showPopup: (text) => dispatch(showPopup(text))
});

export default connect(mapStateToProps, mapDispatchToProps)(LayoutExposition);
